module.exports = __webpack_public_path__ + "img/level-up-alt.f0dd86c6.svg";